module.exports = __webpack_public_path__ + "media/ring.9fdcfe6d.wav";